import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    color: 'white',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },
  rowWrapper: {
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    color: 'white',

    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    _before: {
      display: 'none',
    },
  },
  rowWrapperWithBtn: {
    m: '2',
    mt: '0.5',
    py: '0',
    _before: { display: 'none' },
  },

  tab: {
    bg: 'alpha.500',
    borderBottom: '1px',
    borderColor: 'blackAlpha.400',
    color: 'alpha.900',
    fontSize: '2xs',
    fontWeight: 'bold',
    _first: { ml: '1px' },
    _last: { mr: '1px' },
    _notFirst: { borderLeftWidth: '1px' },
    _selected: {
      bg: 'blackAlpha.300',
      borderBottomColor: 'transparent',
      color: 'white',
    },
  },
};
